import { render, staticRenderFns } from "./userRegistration.vue?vue&type=template&id=08987e5d&"
import script from "./userRegistration.vue?vue&type=script&lang=ts&"
export * from "./userRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./userRegistration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports